import {useAxios} from './use-axios';
import {useAuth} from './use-auth';

const useEmpresas = () => {

    const {getCredentials} = useAuth();
    const { getApiContas } = useAxios();

    /**
     * 
     * @param empresa 
     * 
     * Para nao expor dados sensiveis do sistema, apenas algumas informacoes serao salvas no localstorage
     */
    const salvaSelecaoEmpresa = async (empresa) => {
        const {id, dados, cnpj} = empresa;
        const {razaoSocial, nomeFantasia} = dados;

        const novaEmpresa = {
            id, cnpj,
            dados : {
                cnpj, razaoSocial, nomeFantasia
            }
        }
        const cred = await getCredentials();
        if(cred.username){
            localStorage.setItem("["+cred.username+"].empresaSelecionada",JSON.stringify(novaEmpresa));
        }
    }

    const getEmpresaSelecionada = async (setEmpresa = (empresa) => {}) => {
        const cred = await getCredentials();
        if(cred.username){
            const empresaSelecionadaStr = localStorage.getItem("["+cred.username+"].empresaSelecionada");
            if(empresaSelecionadaStr){
                const empresaSelecionada = JSON.parse(empresaSelecionadaStr);
                setEmpresa(empresaSelecionada);
                return empresaSelecionada;
            }
        }
        const empresaSelecionadaVazia = {id:0};
        setEmpresa(empresaSelecionadaVazia);
        return empresaSelecionadaVazia;
    }

    const listaEmpresas = async (setListaEmpresas = (empresas)=>{}) => {
        try{
            const axios = await  getApiContas();
            const cred = await getCredentials();
            const response = await axios.get('empresas?email=' +cred.username);
            setListaEmpresas(response.data);
            return response.data;
        } catch(err){
            console.log("nao foi possivel listar as empresas", err);
            setListaEmpresas([]);
            return [];
        }
    }

    return {salvaSelecaoEmpresa, getEmpresaSelecionada, listaEmpresas}
}

export {useEmpresas};